import ProductCardNew from '@components/product/product-cards/product-card-new'
import { convertProduct } from '@framework/utils/convert-product'
import { Product } from '@framework/types'

export const PLPSearchHit = ({ hit }: any) => {
  return (
    <div
      key={`${'home-one-deal-of-the-day-products'}-${hit.id}`}
      className={`relative borobazar-alpine-product-card rounded-[10px] bg-white-- transition-all hover:shadow-product-hover shadow-bestSeller bg-white`}
    >
      <ProductCardNew product={convertProduct(hit) as Product} />
    </div>
  )
}
